import { z } from "zod";
import { PublicIdSchema } from "./common";

export const AlcoholCheckResult = z.enum(["pass", "fail"]);

export const AlcoholCheck = z.object({
  public_id: PublicIdSchema,
  attendance_public_id: PublicIdSchema,
  result: AlcoholCheckResult,
  measured_value: z.string().nullable(), // mg/L 0.000-9.999
  checked_at: z.iso.datetime({ offset: true }),
});

export const CreateAlcoholCheckInput = z.object({
  idempotency_key: PublicIdSchema.optional(),
  result: AlcoholCheckResult,
  measured_value: z.string().optional(),
  notes: z.string().optional(),
});

export type AlcoholCheckDto = z.infer<typeof AlcoholCheck>;
export type CreateAlcoholCheckInputDto = z.infer<typeof CreateAlcoholCheckInput>;
export type AlcoholCheckResultDto = z.infer<typeof AlcoholCheckResult>;
